module.exports = __webpack_public_path__ + "static/media/ev14.3177e7b3.jpg";